// noinspection DuplicatedCode
// TODO: 	Refactor stuff related to the TAG itself so it can be reused it here and on the dev tools
//  		Make it on the admin template

const debugWarningStyle = {
	backgroundColor: 'yellow',
	padding: '4px',
	border: 'dotted 2px black',
	boxSizing: 'borderBox',
	height: '36px',
	minWidth: '160px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	userSelect: 'none',
}

const debugContainerStyle = {
	position: 'fixed',
	top: '8px',
	right: '240px',
	zIndex: 10000
}

const debugEntriesStyle = {
	position: 'fixed',
	backgroundColor: 'yellow',
	minWidth: '160px',
}

// const debugEntryStyle = {
// 	borderBottom: 'dotted 2px black',
// 	borderLeft: 'dotted 2px black',
// 	borderRight: 'dotted 2px black',
// 	padding: '4px',
// 	cursor: 'pointer',
// }

const debugStyles = `
	.debugContainer *{
		box-sizing: border-box;
	}
	.debugEntry:hover{
		background-color: #dddd00;
	}
	.debugHidden{
		opacity: 0;
		pointer-events: none;
	}
`

const debugContainer = document.createElement('div');
const debugWarning = document.createElement('div');
const debugEntries = document.createElement('div');

document.addEventListener('DOMContentLoaded', () => {
	Object.assign(debugWarning.style, debugWarningStyle);
	Object.assign(debugContainer.style, debugContainerStyle);
	Object.assign(debugEntries.style, debugEntriesStyle);

	debugWarning.innerText = 'SANDBOX';

	debugEntries.classList.add('debugHidden');

	/** Debug Menu Entries */
	// const menuEntries = [
	// ];
	//
	// const menuEntriesMatches = menuEntries.filter(entry => entry.test());

	debugWarning.addEventListener('mousedown', startDragging)
	debugWarning.addEventListener('touchstart', startDragging)

	// if (menuEntriesMatches.length) {
	// 	debugWarning.innerText += ' ▼'
	// 	debugWarning.style.cursor = 'mouse';
	//
	//
	// 	debugWarning.addEventListener('click', toggleDebugMenu);
	//
	// 	menuEntriesMatches.forEach(entry => {
	// 		const entryElement = document.createElement('div');
	// 		entryElement.innerText = entry.entry;
	// 		entryElement.onclick = entry.action;
	// 		entryElement.classList.add('debugEntry')
	// 		Object.assign(entryElement.style, debugEntryStyle);
	//
	// 		debugEntries.appendChild(entryElement)
	// 	})
	// }

	const debugStylesheet = document.createElement('style');

	debugStylesheet.appendChild(document.createTextNode(debugStyles));
	document.body.appendChild(debugStylesheet);

	debugContainer.className = 'debugContainer';

	debugContainer.appendChild(debugWarning);
	debugContainer.appendChild(debugEntries);
	document.body.appendChild(debugContainer);

	setTimeout(() => {
		const debugEntriesWidth = debugEntries.clientWidth;
		if (debugWarning.clientWidth < debugEntriesWidth) {
			debugWarning.style.width = `${debugEntriesWidth}px`;
		} else {
			debugEntries.style.width = `${debugWarning.clientWidth + 4}px`;
		}
	}, 16)
})

// function toggleDebugMenu() {
//
// 	if (window._dragging)
// 		return;
// 	const closed = debugEntries.classList.contains('debugHidden');
// 	if (closed) {
// 		debugWarning.innerText = 'Test Environment ▲';
// 		debugEntries.classList.remove('debugHidden');
// 	} else {
// 		debugWarning.innerText = 'Test Environment ▼';
// 		debugEntries.classList.add('debugHidden');
// 	}
// }

function startDragging() {
	document.addEventListener('mousemove', dragWarning)
	document.addEventListener("touchmove", dragWarning, {
		passive: false
	});
	document.addEventListener('mouseup', stopDragging)
	document.addEventListener('touchend', stopDragging)
}

let previousTouch = null;

function dragWarning(e) {
	e.preventDefault();

	let top = parseFloat(debugContainer.style.top.split('px')[0]);
	let right = parseFloat(debugContainer.style.right.split('px')[0]);

	let movementX = e.movementX;
	let movementY = e.movementY;

	if (e.touches) {
		const touch = e.touches[0];

		if (previousTouch) {
			movementX = touch.pageX - previousTouch.pageX;
			movementY = touch.pageY - previousTouch.pageY;

		}

		previousTouch = touch;
	}

	window._dragging = true;

	top = top + movementY;
	right = right - movementX;

	if (top >= window.innerHeight - 50) {
		top = window.innerHeight - 50;
	}
	if (top <= 5) {
		top = 5;
	}

	if (right >= window.innerWidth - 200) {
		right = window.innerWidth - 200;
	}
	if (right <= 5) {
		right = 5;
	}


	debugContainer.style.top = `${top}px`;
	debugContainer.style.right = `${right}px`;
}

function stopDragging() {
	document.removeEventListener('mousemove', dragWarning);
	document.removeEventListener('touchmove', dragWarning);
	previousTouch = null;
	setTimeout(() => {
		window._dragging = false;
	}, 50)
}
